import { RoastingSeries, RoastLog } from "../../input/roastingSeriesTypes";

/**
 * 과거 로스팅을 요약한 기준 프로파일
 * kNN 장기 예측의 기준점
 */
export interface PastProfile {
  id: string;
  devTime: number;
  dropBT: number;
  meanROR: number;
  finalLoss: number;
}

export function extractPastProfile(series: RoastingSeries): PastProfile {
  const { id, dryEndTime, dropTime, series: points } = series;

  if (id == null || dryEndTime == null || dropTime == null) {
    throw new Error("extractPastProfile requires dryEndTime and dropTime");
  }

  let rorSum = 0;
  let count = 0;

  for (let i = 1; i < points.length; i++) {
    const prev = points[i - 1];
    const curr = points[i];

    // dev 구간만 사용
    if (prev.time < dryEndTime || curr.time > dropTime) continue;

    const dt = curr.time - prev.time;
    if (dt > 0) {
      rorSum += (curr.bt - prev.bt) / dt;
      count++;
    }
  }

  // drop 시점 BT는 dropTime과 가장 가까운 포인트 사용
  const dropPoint = points.findLast((p) => p.time <= dropTime) ?? points[points.length - 1];

  return {
    id,
    devTime: dropTime - dryEndTime,
    dropBT: dropPoint.bt,
    meanROR: count ? rorSum / count : 0,
    finalLoss: series.actualLoss ?? 0,
  };
}
